<template>
  <nav aria-label="Page navigation">
    <ul>
      <li class="page-item" :class="{ disabled: currentPageEdited == 1 }">
        <a class="page-link" href="#" @click.prevent="setPage(1)"
          >&lt;&lt;</a
        >
      </li>
      <li class="page-item" :class="{ disabled: currentPageEdited == 1 }">
        <a
          class="page-link"
          href="#"
          :class="{ disable: currentPageEdited == 1 }"
          @click.prevent="setPage(currentPageEdited - 1)"
        >
          &lt;</a
        >
      </li>
      <li
        v-for="num in showPagesFix"
        :key="num"
        class="page-item"
        :class="{ active: numFix(num) == currentPageEdited }"
      >
        <template v-if="numFix(num) == currentPageEdited">
          <span class="page-link">{{ numFix(num) }}</span>
        </template>
        <a
          v-else
          class="page-link"
          href="#"
          @click.prevent="setPage(numFix(num))"
          >{{ numFix(num) }}</a
        >
      </li>
      <li
        class="page-item"
        :class="{ disabled: currentPageEdited == totalPages }"
      >
        <a
          class="page-link"
          href="#"
          @click.prevent="setPage(currentPageEdited + 1)"
          >&gt;</a
        >
      </li>
      <li
        class="page-item"
        :class="{ disabled: currentPageEdited == totalPages }"
      >
        <a class="page-link" href="#" @click.prevent="setPage(totalPages)"
          >&gt;&gt;</a
        >
      </li>
    </ul>
  </nav>
</template>

<script>
import { computed, ref, watch } from "@vue/runtime-core";
export default {
  name: "BasePagination",
  props: {
    showPages: {
      default: 1,
      require: false,
      type: Number,
    }, //ページネーションを何件表示するか
    currentPage: {
      default: 1,
      require: false,
      type: Number,
    }, //現在のページ
    totalCount: {
      default: 1,
      require: false,
      type: Number,
    }, //総件数
    totalPages: {
      default: 1,
      require: false,
      type: Number,
    }, //総ページ数
    perPage: {
      default: 20,
      require: false,
      type: Number,
    }, //1ページあたりの表示件数
  },
  
  data() {
    return {
      active01: false
    }
  },
  emits: ["currentPage"],
  setup(props, { emit }) {
    const currentPageEdited = ref(props.currentPage);
    //ページ番号を計算する
    const numFix = (num) => {
      const ajust = 1 + (props.showPages - 1) / 2;
      let result = num;
      //前ページがマイナスになる場合は1からはじめる
      if (currentPageEdited.value > props.showPages / 2) {
        result = num + currentPageEdited.value - ajust;
      }
      //後ページが最大ページを超える場合は最大ページを超えないようにする
      if (currentPageEdited.value + props.showPages / 2 > props.totalPages) {
        result = props.totalPages - props.showPages + num;
      } //総ページ数が表示ページ数に満たない場合、連番そのまま
      if (props.totalPages <= props.showPages) {
        result = num;
      }
      return result;
    };

    //総記事数が表示ページ数以下の場合に調整する
    const showPagesFix = computed(() => {
      if (props.totalPages < props.showPages) {
        return props.totalPages;
      } else {
        return props.showPages;
      }
    });

    //ページネーションを複数設置したときの対応
    watch(
      () => props.currentPage,
      (newValule) => {
        currentPageEdited.value = newValule;
      }
    );

    //何ページ目を表示するか
    const setPage = (page) => {
      //マイナスにならないようにする
      if (page <= 0) {
        currentPageEdited.value = 1;
      }
      //最大ページを超えないようにする
      else if (page > props.totalPages) {
        currentPageEdited.value = props.totalPages;
      } else {
        currentPageEdited.value = page;
      }
      //親コンポーネントに現在のページを送る
      emit("currentPage", currentPageEdited.value);
    };

return { currentPageEdited, numFix, setPage, showPagesFix};
  },
};
</script>

<style scoped>
nav {
  text-align: center;
  margin: 10px;
}

ul li {
  list-style: none;
  display: inline-block;
}

/* BootStrapのスタイルをとりあえずそのまま使用 */
/* 変えたほうがいいかkも */
.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  color: #0d6efd;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #dee2e6;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: #0a58ca;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  color: #0a58ca;
  background-color: #e9ecef;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
}

.page-link {
  padding: 0.375rem 0.75rem;
}

.page-item:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

</style>